import React from 'react';
import './App.css';

export default function AboutOverview({ onBackClick }) {
  return (
    <main className="about-overview-container">
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '0 16px' }}>
        <button
          className="back-button"
          onClick={() => onBackClick && onBackClick('home')}
          style={{
            backgroundColor: '#0b6b2f',
            color: 'white',
            border: 'none',
            padding: '8px 16px',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px',
            marginBottom: '12px',
            marginTop: '20px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
          }}
        >
          ← ආපසු
        </button>
      </div>

      <div className="about-overview-inner">
        <div className="about-overview-content">
          <h1 className="about-overview-title">හැදින්වීම</h1>
          <hr className="footer-sep" />
          <p className="about-overview-text">
            සබරගමුව පළාතේ ආහාර සම්බන්ධ කෘෂිකාර්මික සංවර්ධනය සදහා 1989
            වර්ෂයේ පළාත් සභා පිහිටුවීමත් සමග මෙම දෙපාර්තමේන්තුව පිහිටුවනු ලැබීය.
            රත්නපුර හා කෑගල්ල යන පරිපාලන දිස්ත්‍රික්ක දෙකේ නියෝජ්‍ය කෘෂිකර්ම
            අධයක්ෂ කාර්යාල දෙක මගින් , සහකාර කෘෂිකර්ම අධ්‍යක්ෂ කලාප 07 ක්
            යටතේ කෘෂිකර්ම උපදේශක කාර්යාල 45 ක් ක්‍රියාත්මක වේ. මෙම කෘෂිකර්ම
            උපදේශක කාර්යාලවල ව්‍යාප්ති නිලධාරීන් ඒ ඒ කාර්යාල බල ප්‍රදේශ වල වගා
            කටයුතු පිළිබදව ගොවීන් සමග සමීපව කටයුතු කර පළාතේ ආහාර
            සුරක්ෂිතයාවය හා ගොවීන්ගේ ජීවන තත්වය නගාසිටුවීම සදහා නිරන්තරයෙන්
            ක්‍රියාකරයි.<br></br><br></br>
            එසේම සේවා සංස්කරණ අභ්‍යාස ආයතනයක් හා දිස්ත්‍රික් කෘෂිකර්ම පුහුනු
            ම්‍යස්ථාන දෙකක් පළාත තුල ඇත. පටක රෝපණ විද්‍යාගාර දෙක මගින් පටක
            රෝපිත පලතුරු පැල නිෂ්පාදනය කරන අතර මධ්‍යම පැල තවාන මගින් හා
            දිස්ත්‍රික් කෘෂිකර්ම පුහුණු මධ්‍යස්ථාන දෙක මගින් උසස් තත්වයේ පලතුරු පැල
            නිෂ්පාදනය කරයි. බිම්මල් බීජ මධ්‍යස්ථානය මගින් පළාතට අවශ්‍ය බිම්මල් බීජ
            නිෂ්පාදනය කරන අතර පාංශ රසායනාගාර මගින් පස් සාම්පල් පරික්ෂා කර
            වාර්තා ලබාදීම සිදුකරයි. අක්කර 33 ක වපසරියකින් යුක්ක මාරුක්වතුර
            ගොවිපල සරුසාර පොල් වගාවකින් සමන්විත වේ.<br></br><br></br>
            සබරගමුව පළාත සැලකූ විට විවිධ කෘෂි පාරිසරික ලක්ෂණ වලින් සමන්විත වේ. වාර්ෂික වර්ෂාපතනය
            මි. මී. 2500 - මි.මී. 3360 වන අතර උෂ්නත්වය සෙල්සියස් අංශක 9 සිට 33 ක පරාසයක් ගනී. වාර්ෂික
            වර්ෂාපතනය අනුව වියලි, අතරමැදි සහ තෙත් යන කලාපයන්ට අයත්වන අතර උච්චත්වය අනුව
            පහතරට, මැදරට සහ උඩරට යන සියළු කලාපයන් ගෙන් සමන්විතය. ප්‍රධාන වශයෙන් රතු කහ
            පොඩ්සොලික් පස සහ රතු දුඹුරු ලැටසොලික් පස් කාංණ්ඩයන්ගෙන් සමන්විත වේ.<br></br><br></br>
            පළාතේ ඉඩම් පරිහරණ රටාව සැලකූවිට පළාතේ මුළු ඉඩම් ප්‍රමාණය හෙක්. 496,800 කි. මෙම ඉඩම්
            ප්‍රමාණයෙන් වැඩි භූමි ප්‍රමාණයක් වැවිලි සහ කෘෂිකාර්මික ඉඩම් වන අතර ප්‍රධාන කාෂිකාර්මික
            බෝග වල වගා වපසරිය සැලකූ විට අස්වද්දන ලද කුඹුරු ඉඩම් ප්‍රමාණය හෙක්ටයාර් 36970 ක් ද
            එළවලු වගා වපසරිය හෙක් 5733 ක් පමණද, අතිරේක ආහාර බෝග සහ වෙනත් හෙක්. 3441 ක් පමණද,
            පලතුරු වගා වපසරිය හෙක් 7624පමණද වේ. මහාවාරි, සුළුවාරි සහ වර්ෂා පෝෂිත යටතේ වී වගාවන්
            සිදුකරන ලබයි.
          </p>
        </div>
        <div className="about-overview-image">
          <img src="/connerimg.png" alt="corner" className="about-corner-image" />
        </div>
      </div>
    </main>
  );
}
